import { render, staticRenderFns } from "./wealthie-signup.vue?vue&type=template&id=6d38c31e&scoped=true&"
import script from "./wealthie-signup.vue?vue&type=script&lang=js&"
export * from "./wealthie-signup.vue?vue&type=script&lang=js&"
import style0 from "./wealthie-signup.vue?vue&type=style&index=0&id=6d38c31e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d38c31e",
  null
  
)

export default component.exports